import { Route } from 'react-router-dom'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import Configuracao from '@/pages/Configuracao'
import BotDashboard from '@/pages/Security/BotDashboard'
import LayoutPrototype from '@/pages/LayoutPrototype'
import PortalCliente from '@/pages/PortalCliente'
import PjAgradaCadastro from '@/pages/PjAgradaCadastro'
import ProposalPresentationPage from '@/pages/ProposalPresentationPage'
import PropostaPublica from '@/pages/PropostaPublica'
import PropostaPublicaV2 from '@/pages/PropostaPublicaV2'
import Indicacoes from '@/pages/Indicacoes'
import PortalIndicacoes from '@/pages/PortalIndicacoes'
import PortalIndicacoesAceitar from '@/pages/PortalIndicacoesAceitar'
import PortalIndicacoesLogin from '@/pages/PortalIndicacoesLogin'
import PortalIndicacoesCadastro from '@/pages/PortalIndicacoesCadastro'
import PortalParceiroConfirmar from '@/pages/PortalParceiroConfirmar'
import ParceirosLanding from '@/pages/parceiros/ParceirosLanding'
import ParceirosLogin from '@/pages/parceiros/ParceirosLogin'
import ParceirosHome from '@/pages/parceiros/ParceirosHome'
import ParceirosIndicacoes from '@/pages/parceiros/ParceirosIndicacoes'
import ParceirosFinanceiro from '@/pages/parceiros/ParceirosFinanceiro'
import { FallbackRedirect } from '@/components/FallbackRedirect'
import { isRocketInstance } from '@/config/instanceProfile'

export function AppClosingRoutes() {
  return (
    <>
      <Route
        path='/configuracao'
        element={
          <ProtectedRoute requiredRole={isRocketInstance ? ['admin', 'manager'] : 'admin'}>
            <Configuracao />
          </ProtectedRoute>
        }
      />
      <Route
        path='/security/bots'
        element={
          <ProtectedRoute requiredRole='admin'>
            <BotDashboard />
          </ProtectedRoute>
        }
      />
      {import.meta.env.DEV && (
        <Route
          path='/layout-prototype'
          element={
            <ProtectedRoute requiredRole='admin'>
              <LayoutPrototype />
            </ProtectedRoute>
          }
        />
      )}
      <Route
        path='/indicacoes'
        element={
          <ProtectedRoute requiredRole={['admin', 'manager', 'closer']}>
            <Indicacoes />
          </ProtectedRoute>
        }
      />
      <Route path='/parceiros' element={<ParceirosLanding />} />
      <Route path='/parceiros/login' element={<ParceirosLogin />} />
      <Route path='/parceiros/cadastro' element={<PortalIndicacoesCadastro />} />
      <Route path='/parceiros/confirmar' element={<PortalParceiroConfirmar />} />
      <Route path='/parceiros/aceitar' element={<PortalIndicacoesAceitar />} />
      <Route
        path='/parceiros/home'
        element={
          <ProtectedRoute requiredRole='indicador'>
            <ParceirosHome />
          </ProtectedRoute>
        }
      />
      <Route
        path='/parceiros/indicacoes'
        element={
          <ProtectedRoute requiredRole='indicador'>
            <ParceirosIndicacoes />
          </ProtectedRoute>
        }
      />
      <Route
        path='/parceiros/financeiro'
        element={
          <ProtectedRoute requiredRole='indicador'>
            <ParceirosFinanceiro />
          </ProtectedRoute>
        }
      />
      <Route path='/portal-indicacoes' element={<PortalIndicacoes />} />
      <Route path='/portal-indicacoes/aceitar' element={<PortalIndicacoesAceitar />} />
      <Route path='/portal-indicacoes/login' element={<PortalIndicacoesLogin />} />
      <Route path='/portal-indicacoes/cadastro' element={<PortalIndicacoesCadastro />} />
      <Route path='/portal/:token' element={<PortalCliente />} />
      <Route path='/pj/cadastro/:token' element={<PjAgradaCadastro />} />
      <Route
        path='/apresentacao'
        element={
          <ProtectedRoute
            requiredRole={
              isRocketInstance ? ['admin', 'closer', 'bdr', 'manager'] : ['admin', 'closer', 'bdr']
            }
          >
            <ProposalPresentationPage />
          </ProtectedRoute>
        }
      />
      <Route path='/p/:proposalId/v2' element={<PropostaPublicaV2 />} />
      <Route path='/p/:proposalId' element={<PropostaPublica />} />
      <Route path='*' element={<FallbackRedirect />} />
    </>
  )
}
